import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import API from 'api'
import { useAuth } from 'context'
import Login from 'screens/login'
import Routes from 'routes/Routes'
// set baseurl to API requests
API.baseUrl = process.env.REACT_APP_API_BASE_URL || `http://localhost:8000/api/v1/`

export default function App() {
  const { user } = useAuth()

  return <Router>{!user ? <Login /> : <Routes user={user} />}</Router>
}
